import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import Settings_vue_vue_type_script_setup_true_lang_default from "./Settings.vue.script.js";
/* empty css                       */
/* empty css                         */
//#region src/views/Settings/Settings.vue
var Settings_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Settings_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-dd2544e6"]]);
//#endregion
export { Settings_default as default };

//# sourceMappingURL=Settings.vue.js.map